// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0e72e227","667":"45f0f698"}[chunkId] + ".chunk.js";
};